import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AppIcon } from '@base/models/enums/app.icons';
import { BasePaginationAbstractComponent } from '@misc/abstracts/base-pagination.abstract.component';
import { IDataTableColumn } from '@models/interfaces/data-table-column.interface';
import { QueryParamsService } from '@services/query-params/query-params.service';

@Component({
  selector: 'data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent<T> extends BasePaginationAbstractComponent {
  @Input() queryParams: QueryParamsService;
  @Input() minWidth: string = '0';
  @Input() isHidePagination: boolean = false;
  @Input() maxHeight: string = 'auto';
  @Input() emptyIcon: AppIcon = AppIcon.NO;
  @Input() reloadButtonName: string;
  @Input() emptyMessage: string = 'MESSAGE.EMPTY_LIST';
  @Input() columns: IDataTableColumn[] = [];
  @Input() rowClick: (row: T) => any;
  @Output() reload: EventEmitter<void> = new EventEmitter<void>();

  get dataSource(): T[] {
    return this.list?.entities ?? [];
  }

  get isEmpty(): boolean {
    return !this.dataSource.length && !this.isLoading;
  }

  get displayedColumns(): string[] {
    return this.columns?.map((column: IDataTableColumn): string => column.columnName);
  }
}
